<template>
  <div class="select-wrapper">
    <template>
      <div class="select" @click="selectTap">
      <!--<div class="select" @click="selectTap" :style="{borderBottom:selectDataObjNew.selectData.length>1?(selectDataObjNew.show?'none':'2rpx solid #E9E9E9'):'2px solid #E9E9E9'}">-->
        <div class="select-option" v-if="selectDataObjNew.selectData[selectDataObjNew.currentIndex]">
          {{selectDataObjNew.selectData[selectDataObjNew.currentIndex].name}}
        </div>
        <!--下拉箭头没有颜色-->
        <!--下拉箭头有颜色-->
        <img :src="selectDataObjNew.arrowColor?'/static/img/common/arrowColor@2x.png':'/static/img/common/arrow@2x.png'" class="arrow" >
      </div>
    </template>
    <template>
      <div class="select-options" v-show="show">
        <span class="option" v-for="(item,index) in selectDataObjNew.selectData" :key="index" @click="optionTap(index, item)" >{{item.name}}</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'dc-select',
  props: {
    selectDataObj: {
      type: Object
    }
  },
  data () {
    return {
      show: false,
      selectDataObjNew: this.selectDataObj
    }
  },
  methods: {
    selectTap: function () {
      this.show = !this.show
    },
    optionTap: function (index, data) {
      this.selectDataObjNew.currentIndex = index
      this.$emit('selectOptionTap', data)
      this.show = !this.show
    }
  }
}
</script>

<style scoped lang="scss">
  .select-wrapper{
    display: inline-block;
  }
  .select{
    height: 56px;
    color: #797C80;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 26px; /*px*/
    border: 2px solid #E9E9E9;
    border-radius: 4px 4px 0 0;
    padding: 8px 12px;
    box-sizing: border-box;
  }
  .select-option{
    color: #4DA6FF;
  }
  .arrow{
    align-self: center;
    margin-left: 10px;
    width: 17px;
    height: 11px;
  }
  .select-options{
    /*height: 0;*/
    text-align: left;
    font-size: 26px; /*px*/
    background: #FFFFFF;
    color: rgba(0,0,0,0.15);
    overflow-y: auto;
    transition: height 0.3s;
    position: absolute;
    box-shadow: 0 6px 16px 0 rgba(0,0,0,0.15);
    z-index: 999;
  }
  .option{
    /*height: 80px;*/
    padding: 20px 34px 20px 18px;
    display: block;
    color: #797C80;
    border-top: 1px solid #E9E9E9;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dc-select/dc-select.vue